import { Base } from "src/app/shared/model/core/base.model";

export class HistorialDCambios extends Base {

    public id_cambio: number;
	public version: string;
	public descripcion: string;
	public elabora: string;
	public autoriza: string;
	public tipo_cambio: string;
	public id_usuario: number;
	public id_tipo: number;

}